import styled from 'styled-components'
import PointerC from 'assets/images/Pointer.svg'
import { ButtonBase } from 'utils/base'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(10, 31, 68, 0.5);
  z-index: var(--modal-z-index);
`
export const ModalContainer = styled.div`
  --radius: 0.8rem;
  display: flex;
  flex-direction: column;
  padding: 3.2rem;
  width: 54rem;
  max-width: 96vw;
  background-color: var(--light);
  border-radius: var(--radius);
`

export const ModalNotificationContainer = styled(ModalContainer)`
  padding: 0;
  width: 42rem;
`

export const NotificationContentContainer = styled.div`
  padding: 3.2rem;
`

export const ModalIcon = styled.span`
  display: inline-block;
  align-self: flex-end;
  cursor: url(${PointerC}), pointer;
`

export const ModalHeading = styled.h4`
  font-weight: 600;
  font-size: 2rem;
  line-height: 2.4rem;
  color: var(--text-dark);
  text-align: center;
  margin-bottom: 0.8rem;
`

export const ModalHeadingInfo = styled(ModalHeading)`
  font-weight: 400;
`

export const ModalContent = styled.p`
  font-size: 1.6rem;
  color: var(--text-medium);
  line-height: 2.4rem;
  text-align: center;
  margin-bottom: 3.2rem;
`

export const ModalContentInfo = styled(ModalContent)`
  letter-spacing: -1.15;
  font-size: 1.4rem;
  margin-bottom: 0;
`

export const ButtonContainerInfo = styled.div`
  text-align: center;
  padding: 1.6rem 0;
  background: var(--grey-200);
  border-bottom-left-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
`

export const RegisterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem;
  border: 1px solid var(--grey-400);
  border-radius: var(--radius);
`

export const RegisterContent = styled.p`
  color: var(--text-medium);
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 2.4rem;
`

export const ModalButton = styled(ButtonBase)`
  color: var(--light);
  font-size: 1.6rem;
  line-height: 2.4rem;
  background-color: var(--brand-700);
  border-radius: 0.6rem;
  height: 4rem;
  padding: 0 1.6rem;
`

export const NotificationButton = styled(ModalButton)`
  font-size: 1.4rem;
`
